// import { Button, debounce, TextField } from "@material-ui/core";
// import React, { useCallback } from "react";


// export const EditableUvidCell = ({ row, field, label }: { row: any, field: string, label: string }) => {
//     const [editedData, setEditedData] = React.useState<{ [key: string]: { [key: string]: string } }>({});
//     const rowId = row.id;
//     const value = editedData[rowId]?.[field] || "";

//     const handleFieldChange = useCallback(
        
//         debounce((rowId: string, field: string, value: string) => {
//             setEditedData(prev => ({
//                 ...prev,
//                 [rowId]: {
//                     ...prev[rowId],
//                     [field]: value,
//                 }
//             }));
//         }, 300),
//         []
        
//     );

    
//     const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         handleFieldChange(rowId, field, e.target.value);
//     };

//     return (
//         <>
//             <TextField
        
//             value={value}
//             onChange={handleChange}
//             label={label}
//             variant="outlined"
//             size="small"
//             fullWidth
//         />       
//         </>
        
        
        
//     );
// };



import { TextField } from "@material-ui/core";
import React, { useEffect, useState, useCallback } from "react";
import debounce from "lodash/debounce";

interface Props {
  row: any;
  field: string;
  label: string;
  value: string;
  onChange: (rowId: string, field: string, value: string) => void;
}

export const EditableUvidCell = ({ row, field, label, value, onChange }: Props) => {
  const rowId = row.id;
  const [inputValue, setInputValue] = useState(value);

  // Sync local input value with external value
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const debouncedChange = useCallback(
    debounce((rowId: string, field: string, value: string) => {
      onChange(rowId, field, value);
    }, 300),
    [onChange]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue); // update local input immediately
    debouncedChange(rowId, field, newValue); // update parent state
  };

  return (
    <TextField
      value={inputValue}
      onChange={handleChange}
      label={label}
      variant="outlined"
      size="small"
      fullWidth
    />
  );
};
